import React, { useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container" style={{ minHeight: "70vh", paddingTop: "40px", paddingBottom: "40px" }}>
      <Container>
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3" style={{ color: "#760B0B", fontSize: "36px" }}>
            Terms and Conditions
          </h1>
          <p className="text-muted" style={{ fontSize: "16px" }}>
            Last Updated: February 2026
          </p>
        </div>

        <Card className="border-0 shadow-lg mb-4" style={{ borderRadius: "20px" }}>
          <Card.Body className="p-5">
            <div style={{ lineHeight: "1.8", color: "#333", textAlign: "left" }}>
              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  1. Acceptance of Terms
                </h3>
                <p>
                  By accessing and using HostelDuniya's platform and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  2. Description of Service
                </h3>
                <p>
                  HostelDuniya provides an online platform that connects hostel owners with students seeking accommodation. Our services include but are not limited to:
                </p>
                <ul>
                  <li>Hostel listing and management services</li>
                  <li>Lead generation and contact information services</li>
                  <li>Payment processing for subscriptions and wallet top-ups</li>
                  <li>Communication tools between hostel owners and students</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  3. User Accounts and Registration
                </h3>
                <h5 className="fw-semibold mt-3 mb-2">3.1 Account Creation</h5>
                <p>To use certain features of our platform, you must register for an account. You agree to:</p>
                <ul>
                  <li>Provide accurate, current, and complete information</li>
                  <li>Maintain and update your information to keep it accurate</li>
                  <li>Maintain the security of your password and identification</li>
                  <li>Accept all responsibility for activities that occur under your account</li>
                </ul>

                <h5 className="fw-semibold mt-3 mb-2">3.2 Account Responsibilities</h5>
                <p>You are responsible for:</p>
                <ul>
                  <li>All activities that occur under your account</li>
                  <li>Maintaining the confidentiality of your account credentials</li>
                  <li>Notifying us immediately of any unauthorized use</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  4. Hostel Owner Obligations
                </h3>
                <p>As a hostel owner, you agree to:</p>
                <ul>
                  <li>Provide accurate and truthful information about your hostel</li>
                  <li>Maintain the quality and safety standards of your accommodation</li>
                  <li>Respond promptly to student inquiries and bookings</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not engage in fraudulent or misleading practices</li>
                  <li>Pay all applicable fees and subscriptions on time</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  5. Payment Terms
                </h3>
                <h5 className="fw-semibold mt-3 mb-2">5.1 Subscription Plans</h5>
                <p>
                  We offer various subscription plans for accessing lead information. All subscription fees are non-refundable unless otherwise stated. Subscription fees are charged in advance on a monthly or annual basis.
                </p>

                <h5 className="fw-semibold mt-3 mb-2">5.2 Wallet System</h5>
                <p>
                  Our platform includes a wallet system where you can add funds to purchase individual leads. Wallet balances are non-refundable but can be used to purchase leads or subscription plans.
                </p>

                <h5 className="fw-semibold mt-3 mb-2">5.3 Payment Processing</h5>
                <p>
                  Payments are processed through secure third-party payment gateways. We do not store your complete payment card information on our servers.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  6. Lead Information and Usage
                </h3>
                <p>
                  Lead information provided through our platform is intended solely for contacting potential tenants. You agree to:
                </p>
                <ul>
                  <li>Use lead information only for legitimate business purposes</li>
                  <li>Not share, sell, or distribute lead information to third parties</li>
                  <li>Comply with applicable data protection and privacy laws</li>
                  <li>Not use lead information for spam or unsolicited communications</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  7. Prohibited Activities
                </h3>
                <p>You agree not to:</p>
                <ul>
                  <li>Use the platform for any illegal or unauthorized purpose</li>
                  <li>Violate any laws in your jurisdiction</li>
                  <li>Transmit any viruses, malware, or harmful code</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Interfere with or disrupt the platform's functionality</li>
                  <li>Impersonate any person or entity</li>
                  <li>Collect or harvest information about other users</li>
                  <li>Use automated systems to access the platform without permission</li>
                </ul>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  8. Intellectual Property
                </h3>
                <p>
                  All content on the HostelDuniya platform, including but not limited to text, graphics, logos, images, and software, is the property of HostelDuniya or its content suppliers and is protected by copyright, trademark, and other intellectual property laws.
                </p>
                <p>
                  You may not reproduce, distribute, modify, create derivative works of, publicly display, or otherwise use our content without our prior written permission.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  9. Disclaimers and Limitations of Liability
                </h3>
                <h5 className="fw-semibold mt-3 mb-2">9.1 Service Availability</h5>
                <p>
                  We strive to provide uninterrupted service but do not guarantee that the platform will be available at all times. We reserve the right to modify, suspend, or discontinue any part of the service at any time.
                </p>

                <h5 className="fw-semibold mt-3 mb-2">9.2 No Warranty</h5>
                <p>
                  The platform is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the platform will be error-free, secure, or uninterrupted.
                </p>

                <h5 className="fw-semibold mt-3 mb-2">9.3 Limitation of Liability</h5>
                <p>
                  To the maximum extent permitted by law, HostelDuniya shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  10. Indemnification
                </h3>
                <p>
                  You agree to indemnify, defend, and hold harmless HostelDuniya, its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or in any way connected with your use of the platform or violation of these Terms.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  11. Termination
                </h3>
                <p>
                  We reserve the right to terminate or suspend your account and access to the platform immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
                </p>
                <p>
                  Upon termination, your right to use the platform will immediately cease. All provisions of these Terms that by their nature should survive termination shall survive.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  12. Dispute Resolution
                </h3>
                <p>
                  Any disputes arising out of or relating to these Terms or the platform shall be resolved through good faith negotiations. If such negotiations fail, disputes shall be subject to the exclusive jurisdiction of the courts in India.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  13. Changes to Terms
                </h3>
                <p>
                  We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last Updated" date. Your continued use of the platform after such changes constitutes acceptance of the new Terms.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  14. Governing Law
                </h3>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
                </p>
              </section>

              <section className="mb-4">
                <h3 className="fw-bold mb-3" style={{ color: "#760B0B" }}>
                  15. Contact Information
                </h3>
                <p>
                  If you have any questions about these Terms and Conditions, please contact us at:
                </p>
                <p className="mb-1">
                  <strong>Email:</strong> hostelduniya24@gmail.com
                </p>
                <p className="mb-1">
                  <strong>Phone:</strong> 7678134697
                </p>
                <p>
                  <strong>Address:</strong> B-116 Rajiv Nagar Budh Bazar
                </p>
              </section>
            </div>
          </Card.Body>
        </Card>

        <div className="text-center mt-4">
          <Link
            to="/"
            className="btn fw-semibold px-4 py-2"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            style={{
              backgroundColor: "#8B0000",
              color: "white",
              borderRadius: "10px",
              textDecoration: "none",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#A00000";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#8B0000";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </Container>
    </div>
  );
}

